// extracted by mini-css-extract-plugin
module.exports = {"container":"SwipeA_container__EdJf2","item":"SwipeA_item__ZkhrF","imageWrap":"SwipeA_imageWrap__ForXt","image":"SwipeA_image__uV3wO"};